var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 17.675C4.66667 17.625 4.82917 17.5833 4.9875 17.55C5.14583 17.5167 5.31667 17.5 5.5 17.5H6.5V5.5H5.5C5.21667 5.5 4.97917 5.59583 4.7875 5.7875C4.59583 5.97917 4.5 6.21667 4.5 6.5V17.675ZM5.5 23.5C4.66667 23.5 3.95833 23.2083 3.375 22.625C2.79167 22.0417 2.5 21.3333 2.5 20.5V6.5C2.5 5.66667 2.79167 4.95833 3.375 4.375C3.95833 3.79167 4.66667 3.5 5.5 3.5H12.5V5.5H8.5V17.5H14.5V14.5H16.5V19.5H5.5C5.21667 19.5 4.97917 19.5958 4.7875 19.7875C4.59583 19.9792 4.5 20.2167 4.5 20.5C4.5 20.7833 4.59583 21.0208 4.7875 21.2125C4.97917 21.4042 5.21667 21.5 5.5 21.5H18.5V13.5H20.5V23.5H5.5ZM17 13.5C17 11.9667 17.5333 10.6667 18.6 9.6C19.6667 8.53333 20.9667 8 22.5 8C20.9667 8 19.6667 7.46667 18.6 6.4C17.5333 5.33333 17 4.03333 17 2.5C17 4.03333 16.4667 5.33333 15.4 6.4C14.3333 7.46667 13.0333 8 11.5 8C13.0333 8 14.3333 8.53333 15.4 9.6C16.4667 10.6667 17 11.9667 17 13.5Z",
    fill: "#6A4E42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon);
export default __webpack_public_path__ + "static/media/feature-icon.59e34b30a5a9b0bdefb34222f4275808.svg";
export { ForwardRef as ReactComponent };